import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['select']

  connect() {
    this.form = this.element.closest('form')
    this.sync = this.sync.bind(this)
    this.form.addEventListener('change', this.sync)
    this.sync()
  }

  disconnect() {
    this.form.removeEventListener('change', this.sync)
  }

  sync(event) {
    if (event && event.target.name !== 'context_type') return

    const context = this.form.querySelector('[name="context_type"]:checked')?.value
    for (const option of this.selectTarget.options) {
      if (!option.dataset.context) continue
      option.hidden = option.disabled = option.dataset.context !== context
    }
    if (this.selectTarget.selectedOptions[0]?.disabled) this.selectTarget.value = ''
  }
}
